import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
// import AuthLayout from "../layout/AuthLayout";
import MainLayout from "../layout/MainLayout";
import ProtectedRouter from "./ProtectedRouter";
import ProfilePage from "../pages/ProfilePage";
import EditProfilePage from "../pages/EditProfilePage";
import TermsAndConditions from "../pages/website/TermsAndConditions";
import PrivacyPolicy from "../pages/website/PrivacyPolicy";
import Membership from "../pages/Membership";
import Rsvp from "../pages/Rsvp";
import ByLaws from "../pages/website/ByLaws";
import AboutUs from "../pages/AboutUs";
import FamilyMember from "../pages/FamilyMember";
import Events from "../pages/Events";
import EventGallery from "../pages/EventGallery";
import Sponsors from "../pages/Sponsors";
import Committee from "../pages/Committee";
// import ManageMembership from "../pages/membership/ManageMembership";
import ChangePassword from "../pages/ChangePassword";
// import PreviewMembership from "../pages/membership/PreviewMembership";
import ContactUs from "../pages/ContactUs";

import CommitteeDetails from "../pages/CommitteeDetails";
import Register from "../pages/Register";
import PastPresident from "../pages/PastPresident";
import PastPresidentDetail from "../pages/PastPresidentDetail";
import EventTickets from "../pages/Event/EventTickets";
import EventDetail from "../pages/EventDetail";
import Dashboard from "../pages/Dashboard";
import Transactions from "../pages/Transactions";

const Router = () => {
  const token = localStorage.getItem("GSTB_token");
  return (
    <Routes>
      {/* <Route element={<AuthLayout />}> */}
      {/* </Route> */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/rsvp" element={<Rsvp />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/events-gallery" element={<EventGallery />} />
        <Route path="/events-gallery/:eventId" element={<EventGallery />} />
        <Route path="/about_us" element={<AboutUs />} />
        <Route path="/contact_us" element={<ContactUs />} />
        <Route path="/event-ticket" element={<EventTickets />} />

        <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/bylaws" element={<ByLaws />} />
        <Route path="/sponsor" element={<Sponsors />} />
        <Route path="/committee" element={<Committee />} />
        <Route path="/past-president" element={<PastPresident />} />
        <Route path="/past-president/:id" element={<PastPresidentDetail />} />

        <Route element={<ProtectedRouter token={token} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/edit-profile" element={<EditProfilePage />} />
          <Route path="/family-member" element={<FamilyMember />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="/committee-detail/:id" element={<CommitteeDetails />} />
          <Route path="/transactions" element={<Transactions />} />
        </Route>
      </Route>
      <Route></Route>
    </Routes>
  );
};

export default Router;
